module.exports = __webpack_public_path__ + "img/nodata.e83a247e.png";